import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({ standalone: false,
    selector: 'irb-filter-chips',
    templateUrl: './filter-chips.component.html',
    styleUrls: ['./filter-chips.component.scss']
})
export class FilterChipsComponent implements OnInit {
    _filterData: any;
    _filterChips: { key: string, value: any }[];
    _dataMap:{ key: string, mapData: { displayName: string, customData: any } }[];
    @Output() removeFilterItem = new EventEmitter<any>();
    constructor() {
    }
    ngOnInit(): void {

    }

    @Input()
    set filterData(data: any) {
        this._filterData = data;
        this._filterChips = [];
        if(this._filterData) {
            Object.entries(this._filterData).map((item: any) => {
                this._filterChips.push(item);
            });
            this.filterVisibleChips();
        }
    }

    @Input()
    set dataMap(value: any) {
        this._dataMap = value;
        this.filterVisibleChips();
    };
    get dataMap() {
        return this._dataMap;
    }

    @Input() context: any;

    getDataMap(key: string) {
        if (this.dataMap && this.dataMap.length > 0) {
            let dataMapObj = this.dataMap.find((x: any) => x.key === key);
            if (dataMapObj) {
                return dataMapObj.mapData;
            } else {
                return {displayName: key, customData: null};
            }

        } else {
            return {displayName: key, customData: null};
        }
    }

    displayFilter(key: string) {
        if (this.dataMap && this.dataMap.length > 0) {
            let dataMapObj = this.dataMap.find((x: any) => x.key === key);
            if (dataMapObj) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;

        }
    }
    onRemoveFilterItem(filterChip: any) {
        this.removeFilterItem.next(filterChip);
    }
    private filterVisibleChips() {
        let filterChips: any[] = [];
        if(this.dataMap && this._filterChips) {
           this._filterChips.forEach((chip: any)=>{
               if(this.displayFilter(chip[0])) {
                   filterChips.push(chip);
               }
           });
           this._filterChips = filterChips;
        }
    }

    clearAllFilters() {
        if (this.context && this.context.parentObject) {
            if (this.context.parentObject && this.context.parentObject.params && this.context.parentObject.params.api)
                this.context.parentObject.params.api.deselectAll();
            if (this.context.parentObject && this.context.parentObject.grid && this.context.parentObject.grid.api)
                this.context.parentObject.grid.api.deselectAll();
            this.context.parentObject.clearAllFilters();
            this.context.parentObject.selectedOrDeSelectedRecords = [];
            this.context.parentObject.isSelectedAll = false;
            this.context.parentObject.headerCheckBoxState = 'unchecked';
            this.context.parentObject.enableDisableBtns();
        }
    }
}
